
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SectionHeading } from '@/components/ui/section-heading';
import { cn } from '@/lib/utils';

const classes = [
  {
    id: 'lil-dragons',
    name: 'Lil\' Dragons',
    ages: '4-7',
    description: "Our Lil' Dragons programme lays the foundation for success, building confidence, coordination, and discipline through fun and structured martial arts training.",
    image: '/images/classes/dragons_cover.jpeg',
    color: 'bg-yellow-500'
  },
  {
    id: 'cadets',
    name: 'Cadets',
    ages: '8-12',
    description: 'Our Cadets programme develops key life skills, combining Taekwondo techniques with discipline, teamwork, and confidence-building in a structured and engaging setting.',
    image: '/images/classes/cadets_cover.jpeg',
    color: 'bg-taekwondo-blue'
  },
  {
    id: 'teens-adults',
    name: 'Teens & Adults',
    ages: '13+',
    description: 'Designed for teens and adults, this programme builds martial arts skills, enhances fitness, and promotes self-improvement in a supportive and challenging environment.',
    image: '/images/classes/t_and_a_cover_2.jpeg',
    color: 'bg-taekwondo-red'
  }
];

export default function ClassesSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          subtitle="Programs for All Ages"
          title="Our Taekwondo Classes"
          gradient={true}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {classes.map((cls, index) => (
            <div 
              key={cls.id}
              className="card-hover rounded-xl overflow-hidden bg-white shadow-md"
            >
              <div className="relative h-60">
                <div className={cn("absolute inset-0 opacity-10", cls.color)} />
                <img
                  src={cls.image}
                  alt={cls.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-4 left-4">
                  <span className={cn(
                    "px-3 py-1 text-xs font-semibold text-white rounded-full",
                    cls.color
                  )}>
                    Ages {cls.ages}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold font-display mb-2">{cls.name}</h3>
                <p className="text-gray-600 mb-4">{cls.description}</p>
                <Button variant="outline" size="sm" asChild>
                  <Link to={`/schedule?filter=${cls.id}`}>
                    View Schedule <ArrowRight className="ml-1 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <h3 className="text-xl font-semibold mb-3">Supplemental Classes</h3>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="py-2 px-4 bg-white rounded-md shadow-sm border">Poomsae</div>
            <div className="py-2 px-4 bg-white rounded-md shadow-sm border">Sparring</div>
            <div className="py-2 px-4 bg-white rounded-md shadow-sm border">Weapons</div>
          </div>
        </div>
      </div>
    </section>
  );
}
